// @aiContributed-2025-10-30
/* eslint-disable no-param-reassign */
import { getRequestDataToLog, getResponseDataToLog, isBulkUpsert } from './bulk-upsert-helpers';
import type {
  AjaxBulkUpsertActivity,
  AjaxBulkUpsertAjaxContext,
  AjaxBulkUpsertInstrumentation,
  AjaxBulkUpsertRequest,
} from '../../types';

const schema = {
  scenario: [{
    name: 'bulkUpsertLoggerScenario',
    value: 'BulkUpsert Logger Scenario',
    setting: {
      hidden: true,
    },
    activity: [
      {
        name: 'bulkUpsertLoggerActivity',
        value: 'BulkUpsert Logger Activity',
        setting: {},
      },
    ],
  }],
};


export class AjaxBulkUpsertEventHandler {
  activity: AjaxBulkUpsertActivity;
  constructor(instrumentation: AjaxBulkUpsertInstrumentation) {
    instrumentation.addScenario(schema);
    const bulkUpsertScenario = instrumentation.bulkUpsertLoggerScenario.create(instrumentation.ScenarioContext);
    this.activity = bulkUpsertScenario.bulkUpsertLoggerActivity.create();
  }

  beforeSendHandler(ajaxContext: AjaxBulkUpsertAjaxContext, [, request]: [unknown, AjaxBulkUpsertRequest]) {
    if (isBulkUpsert(ajaxContext.url)) {
      const beforeStartTime = Date.now();

      const requestInfo = getRequestDataToLog(request.data);
      this.activity.trace(`[BulkUpsert][Request] ${JSON.stringify(requestInfo)}`, ajaxContext.url, ajaxContext.requestId);

      const beforeEndTime = Date.now();
      ajaxContext.bulkUpsertBeforeDuration = beforeEndTime - beforeStartTime;
    }
  }

  successHandler(ajaxContext: AjaxBulkUpsertAjaxContext, [data]: [unknown]) {
    if (isBulkUpsert(ajaxContext.url)) {
      const successStartTime = Date.now();

      const responseInfo = getResponseDataToLog(data);
      this.activity.trace(`[BulkUpsert][Response] ${JSON.stringify(responseInfo)}`, ajaxContext.url, ajaxContext.requestId);

      const successEndTime = Date.now();
      const successDuration = successEndTime - successStartTime;

      if (ajaxContext.bulkUpsertBeforeDuration !== undefined) {
        const totalDuration = ajaxContext.bulkUpsertBeforeDuration + successDuration;
        this.activity.trace(`[BulkUpsert][Duration] ${totalDuration}`, ajaxContext.url, ajaxContext.requestId);
      }
    }
  }
}

